import {jQuery as $, lodash as _} from 'lib/shim';

import {Context} from 'context';
import {waitForRepaint} from 'util/dom';



const SELECTOR = '.organism-privacy-layer';



class OrganismPrivacyLayer {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$acknowledgeButton = this._$element.find('.acknowledge-button');

			this._privacyAlreadyAccepted = window.localStorage.getItem('witzenmann-privacy-accepted') === 'true';

			this._prime();
			this._initPatternLabDemoBehaviour();
		}
	}



	_prime(){
		if( !this._privacyAlreadyAccepted ){
			this._$element.addClass('needs-acknowledgement');

			waitForRepaint(() => {
				this._$element.addClass('waiting-for-acknowledgement');
			});
		}

		this._$acknowledgeButton.on('click', (e) => {
			e.preventDefault();

			window.localStorage.setItem('witzenmann-privacy-accepted', 'true');

			this._$element.cssTransition({addClass : 'privacy-accepted', removeClass : 'wait-for-acknowledgement'}, () => {
				this._$element.removeClass('needs-acknowledgement');
			});
		});
	}



	_initPatternLabDemoBehaviour(){
		if(
			(
				Context.get('runningInPatternLabList')
				|| Context.get('runningInPatternLabDetails')
			) && (this._$element.parent().closest('[class^="organism-"]').length === 0)
		){
			this._privacyAlreadyAccepted = false;

			this._$element.addClass('needs-acknowledgement');
			waitForRepaint(() => {
				this._$element.addClass('waiting-for-acknowledgement');
			});

			this._$acknowledgeButton.off('click').on('click', (e) => {
				e.preventDefault();

				this._$element.cssTransition({addClass : 'privacy-accepted', removeClass : 'wait-for-acknowledgement'}, () => {
					this._$element.removeClass('needs-acknowledgement');
				});
			});
		}
	}

}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);
		new OrganismPrivacyLayer(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}
